/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L8Inputs */

const en_mk_term_l8 = /** @type {(inputs: Mk_Term_L8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✔ AC-2 file   0.0s  src/forms/onboarding.tsx changed`)
};

const id_mk_term_l8 = /** @type {(inputs: Mk_Term_L8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✔ AC-2 file   0.0s  src/forms/onboarding.tsx berubah`)
};

/**
* | output |
* | --- |
* | "✔ AC-2 file 0.0s src/forms/onboarding.tsx changed" |
*
* @param {Mk_Term_L8Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l8 = /** @type {((inputs?: Mk_Term_L8Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L8Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l8(inputs)
	return en_mk_term_l8(inputs)
});